// File Metadata:
// Filename: StyledBadge.js
// Version: 1.00
// Created: 2022-11-28 22:10:21
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Badge } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledBadge = styled(Badge, {
	shouldForwardProp: prop => prop !== 'taskStatus'
})(({ taskStatus, theme }) => ({
	'& .MuiBadge-badge': {
		'backgroundColor': taskStatus,
		'color': taskStatus,
		'boxShadow': `0 0 0 2px ${theme.palette.background.paper}`,
		'&::after': {
			position: 'absolute',
			top: 'translateX(-50%)',
			left: 'translateY(-50%)',
			width: '100%',
			height: '100%',
			borderRadius: '50%',
			animation: 'ripple 1.4s infinite ease-in-out',
			border: '1px solid currentColor',
			content: '""'
		}
	},
	'@keyframes ripple': {
		'0%': {
			transform: 'scale(.8)',
			opacity: 1
		},
		'100%': {
			transform: 'scale(1.8)',
			opacity: 0
		}
	}
}))

export default StyledBadge
